<template>
  <router-view />
</template>

<script>
export default {
  name: 'AdminArea',
  components: {
  },

  props: {
  },

  data: () => ({
  }),

  computed: {
  },

  methods: {
  }
}
</script>

<style lang='scss'>
  .admin-area{
  position: relative;
  }
</style>
